/* Shikhar-style theme copy (16 Oct 2026). The behaviour of store.tomahawk.tools
   — mobile menu, hover clips, cart drawer, gallery thumbs, in-stock filter and
   sort — rewired to Shopify: the cart is Shopify's own (/cart/add.js, /cart.js),
   not a list in the browser, so checkout is the real Shopify checkout. */
(() => {
  const root = (window.shk && window.shk.root) || "/";
  const url = (p) => root.replace(/\/$/, "") + "/" + p;
  const inr = (paise) => {
    const r = paise / 100;
    return "₹" + r.toLocaleString("en-IN", { minimumFractionDigits: r % 1 ? 2 : 0, maximumFractionDigits: 2 });
  };
  const esc = (s) => String(s == null ? "" : s).replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));

  /* mobile menu */
  const toggle = document.getElementById("nav-toggle");
  const mnav = document.getElementById("mobile-nav");
  toggle && toggle.addEventListener("click", () => {
    const hidden = mnav.classList.toggle("hidden");
    toggle.setAttribute("aria-expanded", hidden ? "false" : "true");
  });

  /* search bar + suggestions (17 Oct 2026) */
  const sToggle = document.getElementById("search-toggle");
  const sBox = document.getElementById("shk-search");
  const sQ = document.getElementById("shk-q");
  const sOut = document.getElementById("shk-suggest");
  if (sToggle && sBox) {
    sToggle.addEventListener("click", () => {
      const hidden = sBox.classList.toggle("hidden");
      sToggle.setAttribute("aria-expanded", hidden ? "false" : "true");
      if (!hidden) { mnav && mnav.classList.add("hidden"); toggle && toggle.setAttribute("aria-expanded", "false"); sQ && sQ.focus(); }
    });
    let timer, last = "";
    const money = (v) => "₹" + Number(v).toLocaleString("en-IN", { maximumFractionDigits: 0 });
    const run = async (q) => {
      if (q === last) return; last = q;
      if (q.length < 2) { sOut.classList.add("hidden"); sOut.innerHTML = ""; return; }
      try {
        const r = await fetch("/search/suggest.json?q=" + encodeURIComponent(q) + "&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last");
        const d = await r.json();
        if (q !== last) return;
        const ps = (d.resources && d.resources.results && d.resources.results.products) || [];
        sOut.innerHTML = ps.length
          ? ps.map((p) => '<a class="shk-sug" href="' + esc(p.url) + '">' + (p.image ? '<img src="' + esc(p.image) + (p.image.includes("?") ? "&" : "?") + 'width=96" alt="" width="48" height="48" loading="lazy">' : '<span class="shk-sug-ph"></span>') + '<span class="shk-sug-t">' + esc(p.title) + '</span><span class="shk-sug-p">' + money(p.price) + "</span></a>").join("") +
            '<a class="shk-sug-all" href="/search?type=product&options%5Bprefix%5D=last&q=' + encodeURIComponent(q) + '">See all results for “' + esc(q) + '” →</a>'
          : '<p class="shk-sug-none">No tools match “' + esc(q) + '”. Try a shorter word, like “drill”.</p>';
        sOut.classList.remove("hidden");
      } catch (e) { /* the form still works without suggestions */ }
    };
    sQ && sQ.addEventListener("input", () => { clearTimeout(timer); timer = setTimeout(() => run(sQ.value.trim()), 180); });
    document.addEventListener("keydown", (e) => { if (e.key === "Escape" && !sBox.classList.contains("hidden")) { sBox.classList.add("hidden"); sToggle.setAttribute("aria-expanded", "false"); } });
  }

  /* hover clips: play on hover with a mouse, on tap on a phone */
  const fine = window.matchMedia("(hover: hover) and (pointer: fine)").matches;
  document.querySelectorAll("video[data-vhover]").forEach((v) => {
    const box = v.closest(".group") || v.parentElement;
    if (!box) return;
    if (fine) {
      box.addEventListener("pointerenter", () => v.play().catch(() => {}));
      box.addEventListener("pointerleave", () => { v.pause(); v.currentTime = 0; });
    } else {
      const tap = box.querySelector("[data-tap-video]") || (box.closest(".group") || box).querySelector("[data-tap-video]");
      (tap || null) && tap.addEventListener("click", (e) => {
        e.preventDefault();
        if (v.paused) { v.classList.add("is-playing"); v.play().catch(() => {}); }
        else { v.pause(); v.classList.remove("is-playing"); }
      });
    }
  });

  /* full video in a player with sound, plus a full-screen button */
  const vm = document.getElementById("shk-vmodal");
  if (vm) {
    const vv = vm.querySelector("video");
    const shut = () => { vv.pause(); vm.hidden = true; document.documentElement.style.overflow = ""; };
    document.querySelectorAll("[data-video-open]").forEach((b) => b.addEventListener("click", (e) => {
      e.preventDefault();
      if (vv.getAttribute("src") !== b.dataset.videoOpen) vv.src = b.dataset.videoOpen;
      vm.hidden = false; document.documentElement.style.overflow = "hidden";
      vv.play().catch(() => {});
    }));
    vm.querySelector("[data-vmodal-close]").addEventListener("click", shut);
    vm.addEventListener("click", (e) => { if (e.target === vm) shut(); });
    document.addEventListener("keydown", (e) => { if (e.key === "Escape" && !vm.hidden) shut(); });
    vm.querySelector("[data-vmodal-full]").addEventListener("click", () => {
      if (vv.requestFullscreen) vv.requestFullscreen().catch(() => {});
      else if (vv.webkitEnterFullscreen) vv.webkitEnterFullscreen();
    });
  }

  /* "Buy now" is a cart permalink (/cart/<variant>:1). It REPLACES the cart, so
     any GSTIN the buyer typed is wiped — verified live 19 Oct. Shopify cart
     permalinks DO accept ?attributes[...], also verified, so carry the
     remembered GSTIN across instead of losing it.
     Exposed rather than run once, because two things change this link after the
     page loads: the GSTIN field now on the product page, and the variant picker,
     which rebuilt the href from scratch and silently dropped the attributes. */
  window.shkBuyNow = () => {
    let g = null, n = null;
    try { g = localStorage.getItem("shk-gstin"); n = localStorage.getItem("shk-gstname"); } catch (e) {}
    document.querySelectorAll("a[data-buy-now]").forEach((a) => {
      let base = a.dataset.buyBase;
      if (!base) { base = (a.getAttribute("href") || "").split("?")[0]; a.dataset.buyBase = base; }
      if (!base) return;
      if (!g) { a.setAttribute("href", base); return; }
      let q = "?attributes[gstin_number]=" + encodeURIComponent(g);
      if (n) q += "&attributes[company_name]=" + encodeURIComponent(n);
      a.setAttribute("href", base + q);
    });
  };
  window.shkBuyNow();

  /* cart drawer on Shopify's AJAX cart */
  const drawer = document.getElementById("cart-drawer");
  const open = () => { drawer && drawer.classList.add("open"); document.documentElement.style.overflow = "hidden"; };
  const close = () => { drawer && drawer.classList.remove("open"); document.documentElement.style.overflow = ""; };
  let cart = null;

  function render() {
    const count = cart ? cart.item_count : 0;
    document.querySelectorAll("[data-cart-count]").forEach((el) => { el.textContent = count; el.classList.toggle("hidden", count === 0); });
    const list = document.getElementById("cart-items");
    const foot = document.getElementById("cart-foot");
    if (!list) return;
    if (!cart || !cart.items.length) {
      list.innerHTML = '<div class="py-20 text-center text-[--color-fog]"><p class="font-bold text-ink">Your cart is empty</p><p class="text-sm mt-1">Add a tool to get started.</p></div>';
      foot && foot.classList.add("hidden");
      return;
    }
    foot && foot.classList.remove("hidden");
    list.innerHTML = cart.items.map((it) => {
      const img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, "_160x160$1$2") : "";
      const variant = it.variant_title && it.variant_title !== "Default Title" ? `<p class="text-xs text-[--color-fog]">${esc(it.variant_title)}</p>` : "";
      return `
      <div class="flex gap-3 py-4 border-b border-[--color-line]">
        ${img ? `<img src="${esc(img)}" alt="" class="w-20 h-20 rounded-lg object-cover bg-paper border border-[--color-line]"/>` : ""}
        <div class="flex-1 min-w-0">
          <a href="${esc(it.url)}" class="text-sm font-bold leading-tight line-clamp-2">${esc(it.product_title)}</a>
          ${variant}
          <p class="text-sm text-[--color-fog] mt-0.5">${inr(it.final_line_price)}</p>
          <div class="mt-2 flex items-center gap-2">
            <div class="inline-flex items-center border border-[--color-line] rounded-lg">
              <button data-dec="${esc(it.key)}" data-q="${it.quantity}" class="px-2.5 py-1 text-lg leading-none hover:text-blaze" aria-label="One less">−</button>
              <span class="px-2 text-sm font-bold tabular-nums">${it.quantity}</span>
              <button data-inc="${esc(it.key)}" data-q="${it.quantity}" class="px-2.5 py-1 text-lg leading-none hover:text-blaze" aria-label="One more">+</button>
            </div>
            <button data-rm="${esc(it.key)}" class="ml-auto text-xs text-[--color-fog] hover:text-blaze underline">Remove</button>
          </div>
        </div>
      </div>`;
    }).join("");
    const total = document.getElementById("cart-total");
    total && (total.textContent = inr(cart.total_price));
  }

  async function load() {
    try { cart = await (await fetch(url("cart.js"), { headers: { Accept: "application/json" } })).json(); } catch (e) { cart = null; }
    render();
  }

  async function add(id, qty, btn) {
    btn && (btn.disabled = true);
    try {
      const r = await fetch(url("cart/add.js"), {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: qty || 1 }] }),
      });
      if (!r.ok) {
        const e = await r.json().catch(() => ({}));
        alert(e.description || e.message || "Sorry, that could not be added to the cart.");
        return;
      }
      await load();
      open();
    } finally { btn && (btn.disabled = false); }
  }

  async function change(key, qty) {
    await fetch(url("cart/change.js"), {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: Math.max(0, qty) }),
    });
    await load();
  }

  document.addEventListener("click", (e) => {
    const a = e.target.closest("[data-add]");
    if (a) {
      e.preventDefault();
      let d = {};
      try { d = JSON.parse(a.dataset.add); } catch (_) {}
      if (d.id) add(d.id, Number(a.dataset.qty || 1), a);
      return;
    }
    if (e.target.closest("[data-open-cart]")) { e.preventDefault(); open(); return; }
    if (e.target.closest("[data-close-cart]")) { close(); return; }
    if (e.target.id === "cart-scrim") { close(); return; }
    const inc = e.target.closest("[data-inc]"), dec = e.target.closest("[data-dec]"), rm = e.target.closest("[data-rm]");
    if (inc) change(inc.dataset.inc, Number(inc.dataset.q) + 1);
    if (dec) change(dec.dataset.dec, Number(dec.dataset.q) - 1);
    if (rm) change(rm.dataset.rm, 0);
  });
  document.addEventListener("keydown", (e) => { if (e.key === "Escape") close(); });
  load();

  /* product page: swipeable gallery (photo, video, photos) and the variant picker */
  const gal = document.querySelector("[data-gal]");
  if (gal) {
    const track = gal.querySelector("[data-gal-track]");
    const slides = [...track.querySelectorAll("[data-slide]")];
    const dots = [...gal.querySelectorAll(".shk-gal-dots span")];
    const thumbs = [...document.querySelectorAll("[data-thumb]")];
    let cur = 0;
    const go = (i) => { i = Math.max(0, Math.min(slides.length - 1, i)); track.scrollTo({ left: slides[i].offsetLeft, behavior: "smooth" }); };
    const mark = () => {
      const i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      if (i === cur) return;
      cur = i;
      dots.forEach((d, k) => d.classList.toggle("on", k === i));
      thumbs.forEach((t) => t.classList.toggle("on", Number(t.dataset.thumb) === i));
      slides.forEach((s, k) => { const v = s.querySelector("video"); if (v && k !== i && !v.paused) v.pause(); });
    };
    let raf; track.addEventListener("scroll", () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(mark); }, { passive: true });
    thumbs.forEach((t) => t.addEventListener("click", () => go(Number(t.dataset.thumb))));
    const prev = gal.querySelector("[data-gal-prev]"), next = gal.querySelector("[data-gal-next]");
    prev && prev.addEventListener("click", () => go(cur - 1));
    next && next.addEventListener("click", () => go(cur + 1));
    track.addEventListener("keydown", (e) => { if (e.key === "ArrowLeft") go(cur - 1); if (e.key === "ArrowRight") go(cur + 1); });
    gal.querySelectorAll("[data-vplay]").forEach((b) => {
      const v = b.parentElement.querySelector("video");
      b.addEventListener("click", () => { v && v.play().catch(() => {}); });
      v && v.addEventListener("play", () => b.remove());
    });
  }
  const sel = document.querySelector("[data-variant-select]");
  if (sel) sel.addEventListener("change", () => {
    const o = sel.selectedOptions[0];
    const btn = document.querySelector("[data-main-add]");
    btn && (btn.dataset.add = JSON.stringify({ id: Number(sel.value) }));
    /* set the BASE and re-run, never the href: assigning it here wiped the
       GSTIN attributes shkBuyNow had just put on the link */
    const now = document.querySelector("[data-buy-now]");
    if (now) { now.dataset.buyBase = "/cart/" + sel.value + ":1"; window.shkBuyNow(); }
    const set = (q, v) => { const el = document.querySelector(q); if (!el) return; if (v) { el.classList.remove("hidden"); } else { el.classList.add("hidden"); } };
    const price = document.querySelector("[data-pdp-price]"); price && (price.textContent = o.dataset.price);
    const cmp = document.querySelector("[data-pdp-compare]"); cmp && (cmp.textContent = "M.R.P. " + o.dataset.compare); set("[data-pdp-compare]", o.dataset.compare);
    const sv = document.querySelector("[data-pdp-save]"); sv && (sv.textContent = "Save " + o.dataset.save); set("[data-pdp-save]", o.dataset.save);
    const cp = document.querySelector("[data-pdp-code-price]"); cp && o.dataset.code && (cp.textContent = o.dataset.code);
    const u = new URL(location.href); u.searchParams.set("variant", sel.value); history.replaceState(null, "", u);
  });

  /* collection: filters, "In stock only" and sort, all in the browser.
     Facets come from the collection metafield tmhk.filters (17 Oct 2026). */
  const grid = document.getElementById("grid");
  /* Shopify gives at most 250 products per page. A bigger collection (Shop All)
     fetches its other pages here first, so sort and filters see every product.
     Without JS the Previous/Next links still work. (4 Nov 2026) */
  const more = grid && grid.hasAttribute("data-shk-grid") ? Number(grid.dataset.pages || 1) : 1;
  const loadRest = () => {
    if (more < 2 || !grid.dataset.section) return Promise.resolve();
    const pages = [];
    for (let pg = 2; pg <= more; pg++) {
      const u = new URL(location.href);
      u.searchParams.set("page", pg); u.searchParams.set("section_id", grid.dataset.section);
      pages.push(fetch(u).then((r) => (r.ok ? r.text() : "")).catch(() => ""));
    }
    return Promise.all(pages).then((htmls) => {
      let ok = true;
      htmls.forEach((h) => {
        if (!h) { ok = false; return; }
        const d = new DOMParser().parseFromString(h, "text/html");
        d.querySelectorAll("#grid .prod").forEach((el) => grid.appendChild(document.importNode(el, true)));
      });
      const nav = document.getElementById("shk-pager");
      if (ok && nav) nav.remove();
    });
  };
  if (grid && grid.hasAttribute("data-shk-grid")) loadRest().then(() => {
    const items = [...grid.querySelectorAll(".prod")];
    const empty = document.getElementById("empty");
    const only = document.getElementById("only-stock");
    const sort = document.getElementById("sort");
    const n = (el, k) => Number(el.dataset[k] || 0);
    const BUCKETS = [[0, 100000, "Under ₹1,000"], [100000, 250000, "₹1,000 – ₹2,500"], [250000, 500000, "₹2,500 – ₹5,000"], [500000, 1000000, "₹5,000 – ₹10,000"], [1000000, 1e15, "Over ₹10,000"]];
    items.forEach((el) => {
      let f = {};
      try { f = JSON.parse(el.dataset.f || "{}") || {}; } catch (e) { f = {}; }
      const p = n(el, "price"), b = BUCKETS.find((x) => p >= x[0] && p < x[1]);
      f.price = b ? b[2] : null;
      el._f = f;
    });
    const has = (el, fc, v) => { const x = el._f[fc.k]; return Array.isArray(x) ? x.includes(v) : x === v; };
    let facets = [];
    try { facets = JSON.parse((document.getElementById("shk-facets") || {}).textContent || "[]") || []; } catch (e) { facets = []; }
    facets = facets.filter((fc) => fc && fc.k && Array.isArray(fc.v));
    facets.push({ k: "price", l: "Price", m: 0, v: BUCKETS.map((b) => b[2]) });
    facets.forEach((fc) => { fc.v = fc.v.filter((v) => items.some((el) => has(el, fc, v))); });
    facets = facets.filter((fc) => fc.v.length >= 2);

    const sel = {};
    const url = new URL(location.href);
    facets.forEach((fc) => {
      const raw = url.searchParams.get("f." + fc.k);
      sel[fc.k] = new Set(raw ? raw.split("|").filter((v) => fc.v.includes(v)) : []);
    });
    const match = (el, skip) => {
      if (only && only.checked && el.dataset.stock !== "1") return false;
      for (const fc of facets) {
        if (fc.k === skip) continue;
        const s = sel[fc.k];
        if (!s || !s.size) continue;
        const vals = [...s];
        const ok = fc.m ? vals.every((v) => has(el, fc, v)) : vals.some((v) => has(el, fc, v));
        if (!ok) return false;
      }
      return true;
    };

    const panel = document.getElementById("f-panel");
    const groups = document.getElementById("f-groups");
    const openBtn = document.getElementById("f-open");
    const count = document.getElementById("f-count");
    const nOut = document.getElementById("f-n");
    const active = document.getElementById("f-active");
    const wrap = document.getElementById("f-wrap");
    const scrim = document.getElementById("f-scrim");
    if (facets.length && panel && groups) {
      panel.hidden = false;
      openBtn && openBtn.classList.remove("hidden");
      wrap && wrap.classList.add("has-f");
      groups.innerHTML = facets.map((fc) =>
        '<fieldset class="shk-fgroup"><legend>' + esc(fc.l) + "</legend>" +
        fc.v.map((v) => '<label class="shk-fopt"><input type="checkbox" data-k="' + esc(fc.k) + '" data-v="' + esc(v) + '"' + (sel[fc.k].has(v) ? " checked" : "") + '><span class="shk-fv">' + esc(v) + '</span><span class="shk-fn"></span></label>').join("") +
        "</fieldset>").join("");
    }
    const boxes = groups ? [...groups.querySelectorAll("input[data-k]")] : [];

    const apply = () => {
      let shown = 0;
      items.forEach((el) => { const ok = match(el); el.classList.toggle("hidden", !ok); ok && shown++; });
      empty && empty.classList.toggle("hidden", shown > 0);
      nOut && (nOut.textContent = shown);
      boxes.forEach((b) => {
        const fc = facets.find((f) => f.k === b.dataset.k);
        const c = items.filter((el) => match(el, fc.m ? null : fc.k) && has(el, fc, b.dataset.v)).length;
        b.parentElement.querySelector(".shk-fn").textContent = c;
        b.disabled = !c && !b.checked;
        b.parentElement.classList.toggle("is-off", !c && !b.checked);
      });
      const picked = [];
      facets.forEach((fc) => sel[fc.k].forEach((v) => picked.push([fc, v])));
      if (count) { count.textContent = picked.length; count.classList.toggle("hidden", !picked.length); }
      if (active) {
        active.innerHTML = picked.map(([fc, v]) => '<button type="button" class="shk-pill" data-k="' + esc(fc.k) + '" data-v="' + esc(v) + '">' + esc(v) + ' <span aria-hidden="true">×</span></button>').join("") +
          (picked.length > 1 ? '<button type="button" class="shk-pill-clear" data-f-clear>Clear all</button>' : "");
        active.classList.toggle("hidden", !picked.length);
      }
      const u = new URL(location.href);
      facets.forEach((fc) => { const s = sel[fc.k]; s.size ? u.searchParams.set("f." + fc.k, [...s].join("|")) : u.searchParams.delete("f." + fc.k); });
      history.replaceState(null, "", u);
    };
    const clearAll = () => { facets.forEach((fc) => sel[fc.k].clear()); boxes.forEach((b) => (b.checked = false)); apply(); };
    groups && groups.addEventListener("change", (e) => {
      const b = e.target.closest("input[data-k]"); if (!b) return;
      const s = sel[b.dataset.k]; b.checked ? s.add(b.dataset.v) : s.delete(b.dataset.v);
      apply();
    });
    document.addEventListener("click", (e) => {
      const pill = e.target.closest(".shk-pill");
      if (pill) {
        sel[pill.dataset.k] && sel[pill.dataset.k].delete(pill.dataset.v);
        boxes.forEach((b) => { if (b.dataset.k === pill.dataset.k && b.dataset.v === pill.dataset.v) b.checked = false; });
        apply();
      }
      if (e.target.closest("[data-f-clear], #f-clear")) { clearAll(); only && only.checked && ((only.checked = false), apply()); }
    });
    const setOpen = (o) => {
      if (!panel) return;
      panel.classList.toggle("open", o); scrim && scrim.classList.toggle("open", o);
      document.documentElement.classList.toggle("shk-noscroll", o);
      openBtn && openBtn.setAttribute("aria-expanded", o ? "true" : "false");
    };
    openBtn && openBtn.addEventListener("click", () => setOpen(true));
    ["f-close", "f-apply"].forEach((id) => { const b = document.getElementById(id); b && b.addEventListener("click", () => setOpen(false)); });
    scrim && scrim.addEventListener("click", () => setOpen(false));
    document.addEventListener("keydown", (e) => { if (e.key === "Escape") setOpen(false); });

    const order = (how) => {
      [...items].sort((a, b) =>
        how === "price-asc" ? n(a, "price") - n(b, "price") :
        how === "price-desc" ? n(b, "price") - n(a, "price") :
        how === "discount" ? n(b, "discount") - n(a, "discount") :
        (n(b, "stock") - n(a, "stock")) || ((n(a, "pin") || 999) - (n(b, "pin") || 999)) || (n(a, "spare") - n(b, "spare")) || (n(b, "value") - n(a, "value")) || (n(a, "i") - n(b, "i"))
      ).forEach((el) => grid.appendChild(el));
    };
    only && only.addEventListener("change", apply);
    sort && sort.addEventListener("change", (e) => order(e.target.value));
    order("featured");
    apply();
  });
})();

/* 30 Oct 2026: hide the sale-code line once its last day is over, even on a cached page */
(() => {
  /* 4 Nov 2026: the sale-code line is a tap-to-apply link. Shopify keeps the code in a
     discount_code cookie; we also remember the tap, in case that cookie is not readable. */
  const link = document.querySelector("a[data-pdp-code]");
  if (link) {
    const code = link.dataset.code || "";
    let tapped = false;
    try { tapped = localStorage.getItem("shk-code-applied") === code; } catch (e) {}
    const inCookie = document.cookie.split("; ").some((c) => c === "discount_code=" + encodeURIComponent(code) || c === "discount_code=" + code);
    if (tapped || inCookie) {
      const t = link.querySelector("[data-pdp-code-tap]"), ok = link.querySelector("[data-pdp-code-ok]");
      t && t.classList.add("hidden"); ok && ok.classList.remove("hidden");
    }
    link.addEventListener("click", () => {
      try { localStorage.setItem("shk-code-applied", code); } catch (e) {}
      const q = location.search; /* keep the chosen variant when Shopify sends them back */
      if (q) link.href = link.href.split("?redirect=")[0] + "?redirect=" + encodeURIComponent(location.pathname + q);
    });
  }
  document.querySelectorAll("[data-until]").forEach((el) => {
    const t = Date.parse(el.dataset.until);
    if (t && Date.now() > t) el.remove();
  });
})();
